import {
  Alert,
  IconWarningSolid,
  List,
  ScreenReaderContent,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useNotificationState } from "./CustomHooks/NotificationProvider";
import { FAIL, GOOD, WORKING, useStatus } from "./CustomHooks/StatusProvider";

export const SaveAlert = () => {
  const { t } = useTranslation();
  const { notification, setNotification } = useNotificationState();

  return (
    !!notification.type && (
      <Alert
        key={notification.key}
        variant={notification.type}
        timeout={notification.timeout}
        onDismiss={() =>
          setNotification((prev) => ({
            ...prev,
            message: "",
            type: "",
            timeout: 5000,
            key: prev.key,
          }))
        }
        renderCloseButtonLabel={t("notifications.closeNotification")}
      >
        {notification.message}
      </Alert>
    )
  );
};

export const StatusAlert = () => {
  const { t } = useTranslation();
  const { status, toggleStatus } = useStatus();

  return (
    !!status.toggled && (
      <Alert
        renderCloseButtonLabel={t("global.close")}
        onDismiss={() => toggleStatus(false)}
        margin="small 0"
      >
        <List isUnstyled>
          {status.services.length > 0 ? (
            status.services.map((service, index) => (
              <List.Item key={index} size="small" renderIcon={service.icon}>
                {service.name}:{" "}
                <IconWarningSolid
                  color={
                    service.status === GOOD
                      ? "success"
                      : service.status === WORKING
                        ? "warning"
                        : "error"
                  }
                />{" "}
                <ScreenReaderContent>{service.status}</ScreenReaderContent>
                {service.status === FAIL
                  ? t("status.errorOccurred")
                  : `${service.progress}% Complete`}
              </List.Item>
            ))
          ) : (
            <List.Item size="small">{t("status.noServices")}</List.Item>
          )}
        </List>
      </Alert>
    )
  );
};
